import React from 'react';
import './style.less';

interface Props {
  legend: React.ReactNode;
}

export default function Fieldset({ legend, children }: React.PropsWithChildren<Props>) {
  return (
    <fieldset>
      <legend>{legend}</legend>
      {children}
    </fieldset>
  );
}
